import { CFTokens } from '../../../../tokens';
export const BACKGROUND_FILL = {
    ALTERNATE: {
        DISABLED: {
            OFF: CFTokens.COLOR.SALT_16,
            ON: CFTokens.COLOR.SALT_24,
        },
        ENABLED: {
            OFF: CFTokens.COLOR.TEXT_AND_ELEMENT_ALTERNATE_DISABLED,
            ON: CFTokens.COLOR.TEXT_AND_ELEMENT_ALTERNATE_DEFAULT,
        },
    },
    DEFAULT: {
        DISABLED: {
            OFF: CFTokens.COLOR.INK_8,
            ON: CFTokens.COLOR.INK_16,
        },
        ENABLED: {
            OFF: CFTokens.COLOR.TEXT_AND_ELEMENT_DISABLED,
            ON: CFTokens.COLOR.BACKGROUND_BRAND_DARK,
        },
    },
};
export const BACKGROUND_STROKE = {
    ALTERNATE: {
        DISABLED: {
            OFF: CFTokens.COLOR.BORDER_ALTERNATE_DISABLED,
            ON: CFTokens.COLOR.TRANSPARENT,
        },
        ENABLED: {
            OFF: CFTokens.COLOR.BORDER_ALTERNATE_STRONG,
            ON: CFTokens.COLOR.TRANSPARENT,
        },
    },
    DEFAULT: {
        DISABLED: {
            OFF: CFTokens.COLOR.TRANSPARENT,
            ON: CFTokens.COLOR.TRANSPARENT,
        },
        ENABLED: {
            OFF: CFTokens.COLOR.TRANSPARENT,
            ON: CFTokens.COLOR.TRANSPARENT,
        },
    },
};
export const CHECK_FILL = {
    ALTERNATE: {
        DISABLED: CFTokens.COLOR.TEXT_AND_ELEMENT_DEFAULT,
        ENABLED: CFTokens.COLOR.TEXT_AND_ELEMENT_BOOST,
    },
    DEFAULT: {
        DISABLED: CFTokens.COLOR.INK_16,
        ENABLED: CFTokens.COLOR.TEXT_AND_ELEMENT_BRAND,
    },
};
export const CHECK_OPACITY = {
    OFF: 0,
    ON: 1,
};
export const CONTAINER_HEIGHT = 28;
export const CONTAINER_WIDTH = 48;
export const SWITCH_FILL = {
    ALTERNATE: {
        DISABLED: {
            OFF: CFTokens.COLOR.TEXT_AND_ELEMENT_ALTERNATE_DISABLED,
            ON: CFTokens.COLOR.TEXT_AND_ELEMENT_ALTERNATE_DISABLED,
        },
        ENABLED: {
            OFF: CFTokens.COLOR.TEXT_AND_ELEMENT_ALTERNATE,
            ON: CFTokens.COLOR.TEXT_AND_ELEMENT_BRAND,
        },
    },
    DEFAULT: {
        DISABLED: {
            OFF: CFTokens.COLOR.TEXT_AND_ELEMENT_ALTERNATE,
            ON: CFTokens.COLOR.TEXT_AND_ELEMENT_ALTERNATE,
        },
        ENABLED: {
            OFF: CFTokens.COLOR.TEXT_AND_ELEMENT_ALTERNATE,
            ON: CFTokens.COLOR.TEXT_AND_ELEMENT_ALTERNATE,
        },
    },
};
export const SWITCH_X = {
    OFF: 3,
    ON: 21,
};
export const SWITCH_Y = 2;
